import Link from 'next/link';
import { DarkModeToggle } from 'components/DarkModeToggle';
import { userIsAdminOrBeta } from 'lib/helpers';
import { useCurrentUser } from 'lib/contexts/ApplicationState';

interface Props {
  teams?: boolean;
}

const getCurrentYear = () => new Date().getFullYear();

export const CondensedFooter = ({ teams }: Props) => {
  const currentUser = useCurrentUser();
  return (
    <footer className="bg-gray-900 text-white py-8">
      <div className="max-w-7xl mx-4 md:mx-auto">
        <div className="text-sm text-gray-400 flex flex-wrap gap-4 justify-center w-full">
          <Link href="/" className="flex items-center gap-1">
            <img src="/Logo_White.png" alt="Gondola" className="max-w-[24px] max-h-[24px]" />
            {teams ? 'TEAMS' : ''}
          </Link>
          <p>
            ©
            {' '}
            {getCurrentYear()}
            {' '}
            Gondola
          </p>
          <p><Link href="/privacy" className="hover:text-teal">Privacy Policy</Link></p>
          <p><Link href="/terms" className="hover:text-teal">Terms of Service</Link></p>
          <p><Link href="https://status.gondola.cc" className="hover:text-teal">Status</Link></p>
          <p><Link href="https://help.gondola.cc" className="hover:text-teal">Help Center</Link></p>
          <p>{userIsAdminOrBeta(currentUser) && <DarkModeToggle />}</p>
        </div>
      </div>
    </footer>
  );
};
